import React from 'react';
import { 
    List, 
    Datagrid, 
    TextField,
    usePermissions,
    useResourceContext,
    EditButton,
    Filter,
    SearchInput,
    SelectInput,
    BooleanField
} from 'react-admin';
import { processPermissions, isAdminUser } from "../../common/roleUtils";

const BranchFilter = (props) => (
    <Filter {...props} variant='outlined'>
        <SearchInput source='branch_name' alwaysOn placeholder="Search by branch name" />
        <SearchInput source='branch_code' placeholder="Search by code" />
        <SelectInput source='city' choices={[
            { id: 'AJMER', name: 'Ajmer' },
            { id: 'BHILWARA', name: 'Bhilwara' },
            { id: 'BEAWAR', name: 'Beawar' },
            { id: 'PARBATSAR', name: 'Parbatsar' },
        ]} />
    </Filter>
);

export const BranchList = props => {
    const { permissions } = usePermissions();
    const resource = useResourceContext();
    
    // Use utility function to process permissions with role-based restrictions
    const propsObj = processPermissions(permissions, resource);
    
    // Enable bulk actions only for admin users (role_id = 1)
    const allowBulkActions = isAdminUser();
    
    return (
        <React.Fragment>
            <List 
                title="List of Branches" 
                {...props} 
                {...propsObj}
                filters={<BranchFilter />}
                sort={{ field: 'branch_name', order: 'ASC' }}
            >
                <Datagrid rowClick={propsObj.hasEdit ? 'edit' : false} bulkActionButtons={allowBulkActions ? undefined : false}>
                    {propsObj.hasEdit && <EditButton />}
                    <TextField source="id" />
                    <TextField source="branch_code" label="Code" />
                    <TextField source="branch_name" label="Branch Name" />
                    <TextField source="city" label="City" />
                    <TextField source="address" label="Address" />
                    <TextField source="mobile_number" label="Phone" />
                    <TextField source="email" label="Email" />
                    <BooleanField source="is_active" label="Active" />
                </Datagrid>
            </List>
        </React.Fragment>
    )
}
